var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown pai",attrs:{"tag":"li","to":_vm.url,"id":"pai-" + _vm.id,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":_vm.id},on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-856b6322","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/navDropdown.vue
// module id = 820
// module chunks = 245